function Icon() {
  return (
    <svg width='60' height='60' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='60' height='60' rx='8' fill='#E6F0FF' />
      <path
        opacity='0.4'
        d='M16.5 43.5V21C16.5 18 18 16.5 21 16.5H39C42 16.5 43.5 18 43.5 21V34.5C43.5 37.5 42 39 39 39H21L16.5 43.5Z'
        fill='#2A64F6'
      />
      <path
        d='M29.9941 30.1681C29.8711 30.1681 29.748 30.147 29.6265 30.1035C29.049 29.898 28.7356 29.2845 28.9321 28.7025C29.2366 27.8025 30.1259 27.1305 30.7709 26.703C31.7249 26.0685 31.7354 25.4251 31.6604 24.9976C31.5434 24.3361 30.9779 23.7691 30.3149 23.6536C29.8109 23.5621 29.3056 23.6924 28.9156 24.0194C28.5316 24.3419 28.3125 24.813 28.3125 25.3125C28.3125 25.9335 27.8085 26.4375 27.1875 26.4375C26.5665 26.4375 26.0625 25.9335 26.0625 25.3125C26.0625 24.1455 26.5755 23.046 27.4695 22.296C28.3635 21.546 29.5395 21.231 30.705 21.4365C32.2935 21.7155 33.597 23.019 33.876 24.6075C34.1535 26.1855 33.4935 27.5955 32.0175 28.5765C31.1835 29.1315 31.0694 29.412 31.0649 29.424C30.8939 29.877 30.4561 30.1681 29.9941 30.1681ZM31.5286 33C31.5286 32.172 30.8581 31.5 30.0286 31.5H30.0135C29.1855 31.5 28.5209 32.172 28.5209 33C28.5209 33.828 29.2006 34.5 30.0286 34.5C30.8566 34.5 31.5286 33.828 31.5286 33Z'
        fill='#2A64F6'
      />
    </svg>
  );
}

export default Icon;
